export const Colors = {
    buttonColor: '#44A08D',
    buttonHoverColor: '#3E8E41',
    buttonActiveColor: '#2E6E33',
    primary:'#98272B',
    secondary:'#102E50',
    bg:'#090D12',
    bgcard:'#242424',
    inputbg:'#D9D9D9'
};
export default Colors;